/**
 * dashboard/panduan-badges.tsx — N-06 Tutor-facing guide for the badge
 * system. Mirrors leveling-guide's structure: static Indonesian content
 * in 5 sections (overview, dashboard readout, catalog, what-tutor-can-do,
 * FAQ) plus catalog table.
 *
 * Lives at `/dashboard/panduan-badges`. Auth-gated to approved tutors.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/ui/PageHeader.js';
import { BadgeGuide } from '../../components/tutor/BadgeGuide.js';
import { freshSessionQuery } from '../../lib/api/queries.js';

export const Route = createFileRoute('/dashboard/panduan-badges')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role === 'admin') {
      throw redirect({ to: '/admin' });
    }
    if (user.role === 'parent') {
      throw redirect({ to: '/parent' });
    }
    if (user.role !== 'tutor' || !user.isApprovedTutor) {
      throw redirect({ to: '/me' });
    }
    return null;
  },
  component: PanduanBadgesPage,
});

function PanduanBadgesPage(): ReactNode {
  const session = useQuery(freshSessionQuery);
  const userName = session.data?.ok ? session.data.data.user?.name : undefined;

  return (
    <main className="page-shell" data-testid="panduan-badges-page">
      <PageHeader
        eyebrow="Panduan mengajar"
        title="Cara kerja sistem lencana"
        description="Penjelasan filosofi di balik lencana siswa — apa yang otomatis, apa yang bisa kamu manfaatkan untuk memotivasi."
      />

      <BadgeGuide tutorName={userName} />
    </main>
  );
}
